import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";

export default function Submission({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const never = "never" as const;
    const [updatedFee, setUpdatedFee] = useState(submission.fees ?? []);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedFee(submission.fees ?? []);
    }, [submission]);

    const onSaveClick = useCallback(async () => {
        /* 
        setSaving(true);
        AttorneyService.SaveProfile({ body: request }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    if (resp.data?.length === 1) {
                        onSearchComplete(request, resp.data[0]);
                    } else if (resp.data && resp.data?.length > 1) {
                        //We will need to show the modal to select which case
                        setSearchResults(resp.data ?? []);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "No case found");
                    }
                } else {
                    console.log(resp.errorMessage);
                    setErrorMessage(resp.errorMessage ?? "No case found");
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
        */
    }, [updatedFee]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "Description",
                                field: "description",
                            },
                            {
                                title: "Amount",
                                field: "amount",
                            },
                            {
                                title: "Quantity",
                                field: "quantity",
                            },
                        ]}
                        data={updatedFee}
                        title="Fee"
                    />
                </div>
            </div>
        </div>
    );
}
